import { render, staticRenderFns } from "./archiveDialog.vue?vue&type=template&id=20eb5541"
import script from "./archiveDialog.vue?vue&type=script&lang=js"
export * from "./archiveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports